module.exports = __webpack_public_path__ + "static/events_bg.6cd4eb50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/events_bg.jpg
// module id = 1346
// module chunks = 246212416949482 246501157640856